package org.solyton.solawi.bid.module.user.data


typealias UserApplication = Application

/**
 * Alias for [actions]
 */
val userActions by lazy { actions }

/**
 * Alias for [modals]
 */
val userModals by lazy { modals }
